import React, { useEffect } from "react";
import { Field } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { FaUsers } from "react-icons/fa";
import { Typography } from "@progress/kendo-react-common";
import IconComponent from "../../../components/common/IconComponent";
import FormTextField from "../../../components/formFields/FormTextField";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllActiveLeadSource } from "../../leadsource/services/leadsource.service";
import { NAMEPREFIX } from "../../../_contstants/common";
import { requiredValidator, emailValidator, MobileNoIntValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";

interface CustomerHeaderProps {
  leadID?: number;
  inquiryID?: number;
  values: any;
}

const CustomerHeader: React.FC<CustomerHeaderProps> = ({ leadID, inquiryID, values }) => {
  const dispatch = useAppDispatch();
  const { LeadSourceList } = useAppSelector((state) => state.leadsource);

  useEffect(() => {
    dispatch(getAllActiveLeadSource());
  }, [dispatch]);

  const isLinked = (leadID && leadID > 0) || (inquiryID && inquiryID > 0);

  return (
    <ShadowCard className="b2b-quotation-module b2b-card mb-4 p-0">
      <div className="p-4 d-flex gap-3 align-items-start border-bottom border-light">
        <div className="hotel-icon-wrap shadow-sm">
          <IconComponent icon={FaUsers} />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <Typography.h5 className="section-title mb-0">Customer and Quotation Details</Typography.h5>
          </div>
          <Typography.p className="section-subtitle mb-0 mt-1" style={{ fontSize: "13px" }}>
            Basic contact information and source details for this quotation.
          </Typography.p>
        </div>
      </div>

      <div className="p-4">

        <div>
          {isLinked ? (
            <div className="customer-header-summary">
              <table className="w-100" style={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
                <tbody>
                  <tr>
                    <th style={{ width: "120px", textAlign: "left", color: "#6c757d", fontSize: "13px" }}>Name</th>
                    <td style={{ width: "20px", color: "#6c757d" }}>:</td>
                    <td style={{ fontWeight: 700, fontSize: "14px" }}>
                      {values?.Initial} {values?.FirstName} {values?.LastName}
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: "120px", textAlign: "left", color: "#6c757d", fontSize: "13px" }}>Mobile No.</th>
                    <td style={{ width: "20px", color: "#6c757d" }}>:</td>
                    <td style={{ fontWeight: 700, fontSize: "14px" }}>{values?.MobileNo}</td>
                    <th style={{ width: "100px", textAlign: "left", color: "#6c757d", fontSize: "13px" }}>Email ID</th>
                    <td style={{ width: "20px", color: "#6c757d" }}>:</td>
                    <td style={{ fontWeight: 700, fontSize: "14px" }}>{values?.EmailID}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <GridLayout
              cols={[
                { width: "33.33%" },
                { width: "33.33%" },
                { width: "33.33%" },
              ]}
              gap={{ rows: 0, cols: 10 }}
              style={{ marginRight: 20 }}
            >
              <GridLayoutItem className="d-flex gap-2">
                <Field
                  wrapperStyle={{
                    width: "100%",
                    flex: 1,
                  }}
                  id={"Initial"}
                  name={"Initial"}
                  label={"Initial"}
                  placeholder="Mr."
                  component={FormSelectionField}
                  options={NAMEPREFIX?.map((initial: any) => ({
                    value: initial?.value,
                    label: initial?.label,
                  }))}
                />
                <Field
                  wrapperStyle={{
                    width: "100%",
                    flex: 2,
                  }}
                  name="FirstName"
                  label="First Name"
                  placeholder="First Name"
                  maxLength={100}
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="LastName"
                  label="Last Name"
                  placeholder="Last Name"
                  maxLength={100}
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="EmailID"
                  label="Email ID"
                  astrike={true}
                  placeholder="Email ID"
                  component={FormTextField}
                  validator={emailValidator}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="MobileNo"
                  label="Mobile No."
                  type="text"
                  maxLength={16}
                  onKeyPress={(e: any) => {
                    const allowedChars = /^[0-9+]$/;
                    if (!allowedChars.test(e?.key)) {
                      e.preventDefault();
                    }
                  }}
                  placeholder="Mobile Number"
                  component={FormTextField}
                  astrike={true}
                  validator={MobileNoIntValidator}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  wrapperClassName="w-100"
                  id={"LeadSourceID"}
                  name={"LeadSourceID"}
                  label={"Lead Source"}
                  placeholder="Lead Source"
                  component={FormSelectionField}
                  astrike={true}
                  validator={requiredValidator}
                  options={LeadSourceList?.map((leadsource: any) => ({
                    value: leadsource?.ID,
                    label: leadsource?.Source,
                  }))}
                />
              </GridLayoutItem>
            </GridLayout>
          )}
        </div>
      </div>
    </ShadowCard>
  );
};

export default CustomerHeader;
